import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { branch, compose, renderComponent, setPropTypes, withProps } from 'recompose';
import PropTypes from 'prop-types';
import AgentRow from "./AgentRow";
import SidebarNotAvailable from "../../SidebarNotAvailable";
var enhancer = compose(withProps(function (_ref) {
  var application = _ref.application;
  var agent = application && application.agent && Object.keys(application.agent).length > 0 ? application.agent : null;
  return {
    agent: agent
  };
}), branch(function (_ref2) {
  var agent = _ref2.agent;
  return !agent;
}, renderComponent(SidebarNotAvailable)), withProps(function (_ref3) {
  var agent = _ref3.agent;
  var agent_name = agent.first_name ? [agent.first_name, agent.last_name].filter(Boolean).join(' ') : 'Name not available';
  return {
    agent_name: agent_name
  };
}), setPropTypes({
  agent: PropTypes.shape({
    admin_notes: PropTypes.string,
    company_name: PropTypes.string,
    country: PropTypes.string,
    email: PropTypes.string,
    first_name: PropTypes.string,
    id: PropTypes.number,
    last_name: PropTypes.string,
    link: PropTypes.string,
    phone: PropTypes.string
  }),
  agent_name: PropTypes.string,
  application: PropTypes.object
}));
export default enhancer(AgentRow);